import { Paginacao } from "../paginacao";
import { Aviso } from "./aviso";

export class AvisosResponse extends Paginacao {
  avisos: Aviso[];

  /**
   * Usar o parâmetro opcional para receber um objeto da API
   * @param obj
   */
  constructor(obj?: any) {
    super();
    if (obj) {
      this.page = obj.page;
      this.pageSize = obj.pageSize;
      this.totalRows = obj.totalRows;
      this.avisos = obj.avisos.map((a) => new Aviso(a));
    }
  }
}
